import type React from "react";
import { Box, Avatar, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import sunsetbackground from "../../../../assets/sunset-background.png";

interface MemorialHeaderProps {
  firstName: string;
  middleName?: string;
  lastName: string;
  personImage?: string;
}

const MemorialHeader: React.FC<MemorialHeaderProps> = ({
  firstName,
  middleName = "",
  lastName,
  personImage,
}) => {
  const fullName = `${firstName} ${middleName} ${lastName}`.trim();

  return (
    <Box sx={{ width: "100%", position: "relative", pt: 10 }}>
      {/* Background */}
      <Box
        sx={{
          height: { xs: "80px", md: "130px" },
          backgroundImage: `url(${sunsetbackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* Content */}
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "center", md: "center" },
          justifyContent: { xs: "center", md: "flex-start" },
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 1.5, md: 3 },
          px: { xs: 2, md: 10 },
          py: 2,
          textAlign: { xs: "center", md: "left" },
        }}
      >
        {/* Avatar */}
        <Avatar
          src={personImage}
          sx={{
            width: { xs: 80, md: 120 },
            height: { xs: 80, md: 120 },
            borderRadius: "12px",
            border: `3px solid rgba(255,255,255,0.8)`,
            mt: { xs: -6, md: -8 },
            backgroundColor: personImage ? "transparent" : "#bdbdbd",
          }}
        >
          {!personImage && <PersonIcon sx={{ fontSize: 60, color: "#fff" }} />}
        </Avatar>

        {/* Text */}
        <Box>
          <Typography
            variant="body1"
            sx={{
              fontStyle: "italic",
              fontFamily: '"Freehand", cursive',
              fontSize: { xs: "1rem", md: "1.2rem" },
              color: "text.secondary",
              mb: 1,
            }}
          >
            In Loving Memory Of
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              color: "black",
              fontSize: { xs: "1.5rem", md: "2rem" },
            }}
          >
            {fullName}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MemorialHeader;
